// extracted by mini-css-extract-plugin
export default {"add-remove-buttons":"AddRemoveButtons_add-remove-buttons__t9s32","item-amount":"AddRemoveButtons_item-amount__9tdcn","btn":"AddRemoveButtons_btn__bQyCV"};